export default __webpack_public_path__ + "static/media/camara.b72483a1.ico";